<template>
  <Billing :hasFilterContact="true"/>
</template>

<script>
import Billing from '@/views/billing/BillingList'

// this.$refs.bill.query.query = [{ condition: '=' , value: this.$route.params.id , field: 'to_contact'  }]
export default {
  name: "billingList",
  components:{
    Billing
  },
}
</script>
